import {
  ApolloClient,
  createHttpLink,
  gql,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({
  uri: "https://api.fontawesome.com",
});

const authLink = setContext(async (_, { headers }) => {
  // get the authentication token from local storage if it exists
  var token = await getToken();
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token.access_token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

async function getToken() {
  var myHeaders = new Headers({
    Authorization: "Bearer A138BEFD-B185-4849-8C57-3BF7EB585ACF",
  });
  var token = await fetch("https://api.fontawesome.com/token", {
    headers: myHeaders,
    method: "POST",
  });
  return await token.json();
}

export async function getIconsFontawesome() {
  var iconList: any[] = [];
  var fontAwesomeAdminKitId = "66239206c0";
  const result = await client.query({
    query: gql`
      query Search($kitId: String!) {
        me {
          kit(token: $kitId) {
            name
            release {
              iconCount {
                pro
              }
              icons {
                id
                familyStylesByLicense {
                  pro {
                    family
                    style
                  }
                }
              }
            }
          }
        }
      }
    `,
    variables: { kitId: fontAwesomeAdminKitId },
  });

  result.data.me.kit.release.icons.forEach((iconProp: any) => {
    iconList = setStyles(iconProp, iconList);
  });

  return iconList;
}

function setStyles(iconElement: any, iconList: any[]) {
  iconElement.familyStylesByLicense.pro.forEach((styleProp: any) => {
    const iconName = setStyleName(iconElement.id, styleProp);
    iconList.push(iconName);
  });
  return iconList;
}

function setStyleName(iconName: string, styleProp: any) {
  if (styleProp.family === "duotone") {
    return "fa-duotone fa-" + iconName;
  } else if (styleProp.family === "sharp") {
    return "fa-sharp fa-" + styleProp.style + " fa-" + iconName;
  } else {
    return "fa-" + styleProp.style + " fa-" + iconName;
  }
}
